import { pathExists, readJson } from '@wix/cli-fs';
import {
  buildMetadataSchema,
  getBuildManifestPath,
} from '@wix/cli-astro-definitions';
import { CliError, CliErrorCode } from '@wix/cli-error';

export async function readBuildManifest(projectFolder: string) {
  const buildManifestPath = getBuildManifestPath(projectFolder);

  if (!(await pathExists(buildManifestPath))) {
    throw new CliError({
      code: CliErrorCode.BuildOutputMissing({
        reason: `"${buildManifestPath}" build output file is missing.`,
      }),
      cause: null,
    });
  }

  const buildManifestJson = await readJson(buildManifestPath);
  const parseResult = buildMetadataSchema.safeParse(buildManifestJson);

  if (parseResult.success) {
    return parseResult.data;
  }

  throw new CliError({
    code: CliErrorCode.BuildOutputMissing({
      reason: `"${buildManifestPath}" cannot be read.`,
    }),
    cause: parseResult.error,
  });
}
